export default function(toggleClass = 'banner__toggle', headerClass = 'mobile__wrap') {
    $(`.${toggleClass}`).on('click', (event) => {
        $(`.${headerClass}`).toggleClass(`${headerClass}--active`);
        event.preventDefault();
    });
    const subToggleClass = 'nav__link--touch-toggle', subNavItemClass = 'nav__children-wrap';
    $(`.${subToggleClass}`).click(function(){
        $(this).toggleClass(`${subToggleClass}--open`);
        $(this).closest("li").find(`.${subNavItemClass}`).toggleClass(`${subNavItemClass}--open`);
    });
}